<template>
  <div>
    <div class="header d-flex flex-wrap p-2 p-md-4 px-md-5 align-content-center justify-content-between w-100">
      <div class="d-flex align-content-center mb-2 mb-md-0">
        <div class="mr-2">
          <img v-if="$route.name === 'TOEIC_exam'" src="@/assets/image/toeic/toeic_exam/TOEIC.png" alt="" class="object-contain d-inline-block w-100">
          <img v-else src="@/assets/image/toeic/toeic_exam/TOEIC_bridge.png" alt="" class="object-contain d-inline-block w-100">
        </div>
        <div class="">
          <img src="@/assets/image/toeic/toeic_exam/Speaking.png" alt="" class="object-contain d-inline-block" v-if="$route.params.practice_type === 'speaking'">
          <img src="@/assets/image/toeic/toeic_exam/Writing.png" alt="" class="object-contain d-inline-block" v-if="$route.params.practice_type === 'writing'">
        </div>
      </div>
      <div class="d-flex align-items-center">
        <!-- <setVolume v-if="$route.params.practice_type === 'speaking'" /> -->
        <p v-if="$route.params.practice_type === 'writing'" class="px-3 py-1 d-flex align-items-center justify-content-center bg-white rounded pointer font-semibold text-blue-main-toeic text-xl d-inline-block mr-2 mb-0"><img src="@/assets/image/toeic/toeic_exam/show_time.png" alt="" class="mr-1">SHOW TIME |<span class="d-inline-block ml-1" :class="{ 'text-danger': (maxTime - answer_count) < 30 }">{{ formattedTime }}</span></p>
        <a v-if="$route.params.practice_type === 'writing'" class="px-3 py-1 d-flex align-items-center justify-content-center bg-blue-lighter2-toeic rounded pointer font-semibold text-blue-main-toeic text-xl d-inline-block"><img src="@/assets/image/toeic/toeic_exam/help.png" alt="" class="mr-1">Help</a>
      </div>
    </div>

    <div class="content w-100 p-2 p-md-4">
      <div class="content_inner max-w-7xl mx-auto" v-if="examData">
        <!-- speaking -->
        <Speaking2 v-if="$route.params.practice_type === 'speaking'" :speakingData="speakingData" />
        <!-- writing -->
        <!-- <Writing v-if="$route.params.practice_type === 'writing' && $route.name === 'TOEIC_exam'" v-on:emitTime="emitTime" :writingData="writingData" /> -->
        <Writing2 v-if="$route.params.practice_type === 'writing'" v-on:emitTime="emitTime" :writingData="writingData" />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Precautions from '@/components/AiHelper/toeic/precautions'
  import Speaking2 from '@/views/AiHelper/TOEIC/Speaking2'
  import Writing from '@/views/AiHelper/TOEIC/Writing'
  import Writing2 from '@/views/AiHelper/TOEIC/Writing2'
  // import setVolume from '@/components/AiHelper/toeic/setVolume'
  import api from '@/store/api'
  export default {
    name: 'Practice',
    components: {
      Precautions,
      Writing,
      Speaking2,
      Writing2
      // setVolume
    },
    data () {
      return {
        answer_count: null,
        maxTime: 480,
        examData: null,
        elapsedTime: 0
      }
    },
    computed: {
      ...mapGetters([
        'remainPoints'
      ]),
      formattedTime () {
        const m = Math.floor(this.answer_count / 60)
        const s = this.answer_count % 60
        return `${this.pad(m)}:${this.pad(s)}`
      },
      speakingData () {
        return Array.isArray(this.examData?.Parts)
          ? this.examData.Parts.filter(
              el => el.IsSpeaking
            )
          : []
      },
      writingData () {
        return Array.isArray(this.examData?.Parts)
          ? this.examData.Parts.filter(
              el => !el.IsSpeaking
            )
          : []
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      pad (n) {
        return n < 10 ? '0' + n : n
      },
      emitTime (payload) {
        this.answer_count = payload
      },
      getData () {
        let path = `https://api.liveabc.com/v1/livelibrary/Exam/${this.$route.params.exam_id}`

        api.get(path)
        .then((res) => {
          this.examData = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
a {
  &:hover {
    text-decoration: none !important;
  }
}
.content {
  min-height: calc(100vh - 92px);
}
.content_inner {
  min-height: calc(70vh);
}
// .main_inner_outer {
//   min-height: calc(100vh - 92px);
// }
// .main_inner {
//   min-height: 70vh;
// }
.testText {
  width: 80%;
}
.TestingTools {
  width: 20%;
}
.volume-container {
  position: relative;
  display: inline-block;
}
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
}
.volume-container {
  position: relative;
  display: inline-block;
}
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
}
</style>
